<template>
	<div id="modalSlides">
		<div class="swiperWrapper">
			<swiper
				:options="swiperOption"
				class="swiper-box"
				ref="modalSlides"
			>
				<!-- slides -->
				<swiper-slide
					v-for="(slide, index) in slides"
					:key="index"
				>
					<img
						:src="generateImageSrc(index)"
						class="step-image"
					>
					<p
						class="infoText"
						v-html="slide.text">
					</p>
				</swiper-slide>
			</swiper>
		</div>
		<div class="ctrWraper flex">
			<div
				class="btn close"
				@click="close()">
					閉じる
			</div>
			<div
				class="btn slide"
				:class="{disabled:
				isBeginning}"
				@click="slidePrev()"
			>
				前へ
			</div>
			<div class="pageCount" >{{activeIndex}}/{{slides.length}}</div>
			<div
				class="btn slide"
				:class="{disabled: isEnd}"
				@click="slideNexrt()"
			>
				次へ
			</div>
		</div>
	</div>
</template>
<script>
import Mixins from '@/mixins'
import tutorialStep1 from '@/assets/images/tutorial/step_1.png'
import tutorialStep2 from '@/assets/images/tutorial/step_2.png'
import tutorialStep3 from '@/assets/images/tutorial/step_3.png'
import tutorialStep4 from '@/assets/images/tutorial/step_4.png'
import tutorialStep5 from '@/assets/images/tutorial/step_5.png'
import tutorialStep6 from '@/assets/images/tutorial/step_6.png'
import tutorialStep7 from '@/assets/images/tutorial/step_7.png'
import tutorialStep8 from '@/assets/images/tutorial/step_8.png'
import permissionAndroidStep1 from '@/assets/images/permission/android/step_1.png'
import permissionAndroidStep2 from '@/assets/images/permission/android/step_2.png'
import permissionAndroidStep3 from '@/assets/images/permission/android/step_3.png'
import permissionIosStep1 from '@/assets/images/permission/ios/step_1.png'
import permissionIosStep2 from '@/assets/images/permission/ios/step_2.png'
import permissionIosStep3 from '@/assets/images/permission/ios/step_3.png'

export default {
	name: 'ModalSlides',
	props: {
		contentType: String
	},
	mixins: [
		Mixins.navigator
	],
	data () {
		return {
			swiper: {
				main: null
			},
			swiperOption: {
				slidesPerView: 1,
				spaceBetween: 200,
				centeredSlides: true,
				threshold: 5,
				allowSlidePrev: true
			},
			slides: [],
			contents: {
				tutorial: [
					{
						text: '「Googleアカウントでログインするか、新規にアカウントを登録します」',
						img: tutorialStep1
					},
					{
						text: 'EメールアドレスかGoogleアカウントでアカウントを作成します',
						img: tutorialStep2
					},
					{
						text: 'NEXTO STOREは24時間営業です。<br>無人の時間帯は施錠されており、アプリの入口解錠画面からGPS情報を用いて利用者の位置を判定し、ボタンを押して解錠することができます。',
						img: tutorialStep3
					},
					{
						text: '欲しい商品を自由に手に取って頂き、セルフレジ画面からカメラを起動しその商品のバーコードをスキャンすることでお買い物をして頂けます。',
						img: tutorialStep4
					},
					{
						text: 'カメラが起動したら購入する商品のバーコードをスキャンして下さい（iPhoneはSafari、AndroidはChromeのみ動作します）複数個の購入はスキャン後に数量を変更して下さい。',
						img: tutorialStep5
					},
					{
						text: 'カートの商品一覧と合計金額をご確認の上、購入するボタンを押して決済画面に進んで下さい。',
						img: tutorialStep6
					},
					{
						text: '対応端末であればApplePay、GooglePayを使用することができ、スピーディな決済が可能です。また、クレジットカード番号を手入力することも可能です。',
						img: tutorialStep7
					},
					{
						text: '購入内容の明細が表示されます。ログインに使用したメールアドレスにも同様の内容が送信されます。',
						img: tutorialStep8
					}
				],
				permission: {
					android: [
						{
							text: 'アドレスバーにある鍵アイコンをタップします',
							img: permissionAndroidStep1
						},
						{
							text: '位置情報またはカメラの権限を確認します。変更する必要があれば「サイトの設定」をタップします',
							img: permissionAndroidStep2
						},
						{
							text: '位置情報またはカメラの項目をタップすると権限の変更が出来ます',
							img: permissionAndroidStep3
						}
					],
					ios: [
						{
							text: 'アドレスバーにある「AA」アイコンをタップします',
							img: permissionIosStep1
						},
						{
							text: '「Webサイトの設定」をタップします。',
							img: permissionIosStep2
						},
						{
							text: 'カメラ、場所の項目をタップすると権限の変更が出来ます',
							img: permissionIosStep3
						}
					]
				}
			}
		}
	},
	computed: {
		activeIndex () {
			if (this.swiper.main) {
				const { main } = this.swiper
				return main.activeIndex + 1
			}
			return false
		},
		isBeginning () {
			if (this.swiper.main) {
				const { main } = this.swiper
				return main.isBeginning
			}
			return false
		},
		isEnd () {
			if (this.swiper.main) {
				const { main } = this.swiper
				return main.isEnd
			}
			return false
		}
	},
	created () {
		const { contentType, navigator } = this
		if (contentType === 'tutorial') {
			this.slides = this.contents[this.contentType]
		} else if (contentType === 'permission') {
			const key = navigator.userAgent === 'iOS' ? 'ios' : 'android'
			this.slides = this.contents[this.contentType][key]
		}
	},
	mounted () {
		this.set()
	},
	methods: {
		set () {
			const target = 'modalSlides'
			const { swiper } = this.$refs[target]
			this.swiper.main = swiper
		},
		close () {
			this.$emit('closeModalSlides')
		},
		generateImageSrc (index) {
			return this.slides[index].img
		},
		slidePrev () {
			const { main } = this.swiper
			main.slidePrev()
		},
		slideNexrt () {
			const { main } = this.swiper
			main.slideNext()
		}
	}
}
</script>

<style lang="stylus">
@import "~@/themes/styles/common.styl"
@import "~@/themes/styles/mixins.styl"
#modalSlides
	z-index 100
	width 100%
	position fixed
	top 0
	left 0
	background-color main-bg-dark
	height 100%
	padding-bottom 60px
	overflow scroll
	text-align center
	.swiperWrapper
		margin 24px 12px 0 12px
		.swiper-box
			width 100%
			height 100%
			margin 0 auto
		.swiper-slide
			.step-image
				max-width 65%
			.infoText
				text-align left
				font-size 1.1rem
				border-top 1px solid #ccc
				margin-top 12px
				padding-top 12px
	.ctrWraper
		position fixed
		bottom 0
		left 0
		width 100%
		height 60px
		border-top: 1px solid  text-super-light
		background-color dark-color
		color #fff
		z-index 9999
		.btn
			border 1px solid #cccccc
			border 1px solid text-super-light
			border-radius 8px
			margin 6px
			line-height 45px
			&.close
				width: 45%
			&.slide
				flex 1
			&.disabled
				opacity 0.5
		.pageCount
			line-height 60px
			font-size 13px
			width 20px
</style>
